const Rules = {

    // PAGE HEADER
    "rules": "Rules",

    // FIELDS
    "premise": "Premise",
    "title": "Title",
    "description": "Description",
    "upload": "Upload",
    "attachments": "Attachments",
    "status": "Status",
    "rule_type": "Rule Type",
    "rule_type_gen": "General",
    "rule_type_sbk": "Amenities",
    "search": "Search",
    "created_at": "Created At",
    "view": "View",
    "no_file": "No file",

    // TABLE HEADERS
    "table_premise": "PREMISE",
    "table_title": "TITLE",
    "table_created_date": "CREATED DATE",
    "table_status": "STATUS",
    "table_rule_type": "RULE TYPE",

    // ERROR
    "error_premise": "Select Premise",
    "error_title": "Enter Title",
    "error_description": "Enter Description",
    "error_status": "Select Status",
    "error_rule_type": "Select Rule Type",
}

export default Rules;